import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  textField: {
    minWidth: 400,
    marginTop: 8,
  },
  sendButton: {
    width: 150,
    marginTop: 44,
    height: 40,
  },
}));



// WEBPACK FOOTER //
// ./src/components/BuyerMessages/components/DesktopMessages/components/BulkMessaging/useStyles.js